import { apiClient } from '@/lib/api/client'

export type AcknowledgePayload = {
  create_ticket: boolean
}

export type AcknowledgeResult = {
  ticketRequest: Record<string, unknown> | null
  parentTicket: Record<string, unknown> | null
  warnings: string[]
}

export function buildAcknowledgePayload(createTicket = true): AcknowledgePayload {
  return { create_ticket: createTicket }
}

export function parseAcknowledgeResponse(payload: Record<string, unknown>): AcknowledgeResult {
  const ticketRequestWrapper = payload.ticket_request as { data?: Record<string, unknown> } | Record<string, unknown> | undefined
  const parentTicketWrapper = payload.parent_ticket as { data?: Record<string, unknown> } | Record<string, unknown> | undefined

  const unwrapRecord = (value: unknown): Record<string, unknown> | null => {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return value as Record<string, unknown>
    }
    return null
  }

  const ticketRequest =
    ticketRequestWrapper && 'data' in ticketRequestWrapper
      ? unwrapRecord(ticketRequestWrapper.data)
      : unwrapRecord(ticketRequestWrapper)

  const parentTicket =
    parentTicketWrapper && 'data' in parentTicketWrapper
      ? unwrapRecord(parentTicketWrapper.data)
      : unwrapRecord(parentTicketWrapper)

  const rawWarnings = payload.warnings
  const warnings = Array.isArray(rawWarnings)
    ? rawWarnings.filter((w): w is string => typeof w === 'string' && w.trim() !== '')
    : []

  return { ticketRequest, parentTicket, warnings }
}

export async function acknowledgeTicketRequest(
  id: number,
  createTicket = true
): Promise<AcknowledgeResult> {
  const response = await apiClient.post(
    `/support/my-request/${id}/acknowledge`,
    buildAcknowledgePayload(createTicket)
  )

  return parseAcknowledgeResponse(response.data as Record<string, unknown>)
}
